import React, { useRef, useState, useEffect } from 'react';
import { Upload, Modal, Dropdown, Badge, Progress, Button, Input, message } from 'antd';
import { EllipsisOutlined, EyeOutlined, CloseOutlined, PlusOutlined } from '@ant-design/icons';
import commonApiService from "../../config/common_api";
import { triggerNotification } from './notify';
// commonApiService.upload_image_to_bucket
const UploadButton = ({
    product_obj = null,
    setSavedimgaes = null,
    MAX_UPLOADS = 50,
    delete: showDelete = true,
    replace: showReplace = true,
    thumbnail: showThumbnail = true,
    hover: showHover = true
}) => {
    const maxUploads = parseInt(MAX_UPLOADS, 10);
    const [fileList, setFileList] = useState([]);
    const [previewImage, setPreviewImage] = useState('');
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewTitle, setPreviewTitle] = useState('');
    const [assignedRoles, setAssignedRoles] = useState({ thumbnail: null, hover: null });
    const [uploadProgress, setUploadProgress] = useState({});
    const replaceInputRef = useRef(null);
    const [previewMeta, setPreviewMeta] = useState('');
    const [urlModalVisible, setUrlModalVisible] = useState(false);
    const [imageUrlInput, setImageUrlInput] = useState('');
    const recentlyDeletedUid = useRef(null);
    const [urlError, setUrlError] = useState('');
    const [downloadImage, setDownloadImage] = useState(true);


    useEffect(() => {
        document.body.style.overflow = previewVisible ? 'hidden' : '';
        if (product_obj && product_obj.img_data && product_obj.img_data.length > 0) {

            const finalList = product_obj.img_data.map((productimg) => {
                const filename = productimg.url_standard.split('/').pop().split('?')[0];
                return {
                    saved_id: productimg.id,
                    thumbUrl: productimg.url_standard,
                    uid: `${productimg.id}`,
                    name: filename,
                    status: 'done',
                    originFileObj: null,
                    set_as_Featured: productimg.is_thumbnail,
                    img_order: productimg.sort_order
                };
            });

            finalList.sort((a, b) => a.img_order - b.img_order);

            setFileList(finalList);
            const featuredImage = finalList.find(img => img.set_as_Featured);
            if (featuredImage) {
                setAssignedRoles(prev => ({ ...prev, thumbnail: featuredImage.uid }));
            }

            // Automatically set the 2nd image as hover, if exists
            if (finalList.length > 1) {
                setAssignedRoles(prev => ({ ...prev, hover: finalList[1].uid }));
            }
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [product_obj]);

    useEffect(() => {
        const savedImages = fileList.map(file => ({
            is_saved: file.saved_id ? file.saved_id : "",
            uid: file.uid,
            name: file.name,
            thumbUrl: file.thumbUrl,
            originFileObj: null,
            status: file.status,
            set_as_Featured: file.set_as_Featured,
            img_order: file.img_order
        }));
        setSavedimgaes({ image_data: savedImages });
    }, [fileList, setSavedimgaes]);

    const onPreview = async (file) => {
        let src = file.url || file.thumbUrl;
        let sizeFormatted = '';
       
        if(file.saved_id > 0){
            setDownloadImage(true)
        }else{
            setDownloadImage(false)
        }
        

        if (!src && file.originFileObj) {
            src = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
            });
        }

        if (file.originFileObj?.size) {
            sizeFormatted = `${(file.originFileObj.size / 1024).toFixed(1)} kB`;
        } else if (src && !file.originFileObj) {
            try {
                const response = await fetch(src, { method: 'HEAD' });
                const size = response.headers.get('content-length');
                if (size) {
                    sizeFormatted = `${(parseInt(size, 10) / 1024).toFixed(1)} kB`;
                }
            } catch (err) {
                console.warn('Failed to fetch image size:', err);
            }
        }

        const image = new Image();
        image.onload = () => {
            const format = file.name?.split('.').pop().toUpperCase() || 'IMG';
            const dimensions = `${image.naturalWidth} x ${image.naturalHeight}`;
            const meta = `${format} | ${dimensions} | ${sizeFormatted}`;
            setPreviewMeta(meta);
            setPreviewImage(src);
            setPreviewTitle(file.name || 'Image Preview');
            setPreviewVisible(true);
           
        };
        image.onerror = () => {
            console.error("Image failed to load");
            setPreviewImage('');
            setPreviewMeta('Unable to load image.');
            setPreviewVisible(true);
        };
        image.src = src;
    };



    const handleMenuClick = (file, { key }) => {
        if (key === 'delete') {
            recentlyDeletedUid.current = file.uid; // Mark this uid
            setFileList((prev) => prev.filter((item) => item.uid !== file.uid));
            if (file.uid === assignedRoles.thumbnail) setAssignedRoles((prev) => ({ ...prev, thumbnail: null }));
            if (file.uid === assignedRoles.hover) setAssignedRoles((prev) => ({ ...prev, hover: null }));
            return;
        } else if (key === 'replace') {
            replaceInputRef.current?.click();
            replaceInputRef.current.setAttribute('data-replace-id', file.uid);
        } else if (key === 'thumbnail') {
            setAssignedRoles((prev) => ({ ...prev, thumbnail: file.uid }));

            const updatedFileList = fileList.map(f => ({
                ...f,
                set_as_Featured: f.uid === file.uid
            }));
            setFileList(updatedFileList);
        } else if (key === 'hover') {
            setAssignedRoles((prev) => ({
                hover: file.uid,
                thumbnail: prev.thumbnail === file.uid ? null : prev.thumbnail,
            }));

            const updatedFileList = fileList.map(f => ({
                ...f,
                set_as_Featured: f.uid === file.uid ? false : f.set_as_Featured
            }));

            // Reorder: place hover image at index 1 (second)
            const hoverFile = updatedFileList.find(f => f.uid === file.uid);
            const rest = updatedFileList.filter(f => f.uid !== file.uid);
            const reorderedList = [rest[0], hoverFile, ...rest.slice(1)];

            for (let i = 0; i < reorderedList.length; i++) {
                reorderedList[i].img_order = i
            }

            setFileList(reorderedList);

        }
    };

    const handleReplaceFile = async (e) => {
        const file = e.target.files[0];
        const replaceId = replaceInputRef.current?.getAttribute('data-replace-id');
        if (!file || !replaceId) return;

        // isImage check
        const isImage = file.type && file.type.startsWith("image/");
        if (!isImage) {
            triggerNotification({
                type: 'error',
                title: 'Error!',
                message: 'Only image files are allowed',
            });
            return;
        }

        try {
            // Show loading placeholder before upload
            const tempUid = `${Date.now()}`;
            const tempThumb = URL.createObjectURL(file);

            const replacedIndex = fileList.findIndex((f) => f.uid === replaceId);
            const tempFile = {
                uid: tempUid,
                name: file.name,
                status: 'uploading',
                originFileObj: file,
                thumbUrl: tempThumb,
                is_saved: replacedIndex.is_saved
            };

            const newList = [...fileList];
            newList.splice(replacedIndex, 1, tempFile);
            setFileList(newList);

            // Upload to server
            const uploaded_url = await commonApiService.upload_image_to_bucket(file);

            // Update file list with real uploaded URL
            const updatedFile = {
                ...tempFile,
                status: 'done',
                thumbUrl: uploaded_url,
            };

            setFileList((prevList) =>
                prevList.map((f) => (f.uid === tempUid ? updatedFile : f))
            );

        } catch (err) {
            console.error("Replace upload failed:", err);
        }

        replaceInputRef.current?.removeAttribute('data-replace-id');
        e.target.value = null; // Reset input so same file can be selected again
    };

    const Uploaditems = [
        {
            label: (
                <Button
                    className='UploadBtnURL'
                    type="link"
                    onClick={() => setUrlModalVisible(true)}
                >
                    Enter URL
                </Button>
            ),
            key: '1',
        },
    ];

    const menuProps = {
        Uploaditems,
    };
    const getMenuItems = (file) => {
        const items = [];
        if (showDelete) items.push({ key: 'delete', label: 'Delete', danger: true });
        if (showReplace && fileList.length > 0) items.push({ key: 'replace', label: 'Replace' });

        if (showThumbnail && maxUploads > 1 && file.uid !== assignedRoles.thumbnail) {
            items.push({ key: 'thumbnail', label: 'Set as Featured' });
        }

        if (showHover && maxUploads > 1 && file.uid !== assignedRoles.hover) {
            items.push({ key: 'hover', label: 'Set as Hover' });
        }

        return items;
    };

    const handleCopyLink = () => navigator.clipboard.writeText(previewImage);

    const handleDownload = async () => {
        try {
            const response = await fetch(previewImage, { mode: 'cors' });
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = previewTitle || 'downloaded-image';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error('Download failed:', error);
        }
    };

    const handleSort = (startIndex, endIndex) => {
        const deletedUid = recentlyDeletedUid.current;

        // If the item that was supposed to be dragged is deleted, skip sorting
        if (fileList[startIndex]?.uid === deletedUid) {
            recentlyDeletedUid.current = null; // Reset
            return;
        }

        const newList = [...fileList];
        const [movedItem] = newList.splice(startIndex, 1);
        newList.splice(endIndex, 0, movedItem);

        setFileList(newList);

        // Also update assigned roles if needed
        const newHover = assignedRoles.hover;
        const newThumb = assignedRoles.thumbnail;

        setAssignedRoles({
            hover: newList.find((f) => f.uid === newHover)?.uid ?? null,
            thumbnail: newList.find((f) => f.uid === newThumb)?.uid ?? null,
        });

        recentlyDeletedUid.current = null; // Reset at the end as well for safety
    };



    let dragItemIndex = null;

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div>Upload</div>
        </div>
    );

    return (
        <>
            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                {fileList.map((file, index) => {
                    const isThumbnail = assignedRoles.thumbnail === file.uid;
                    const isHover = assignedRoles.hover === file.uid;
                    const label = isThumbnail ? 'Featured' : isHover ? 'Hover' : '';
                    const progress = uploadProgress[file.uid];

                    return (
                        <div
                            key={file.uid}
                            className="image-container"
                            data-sort={file.img_order}
                            draggable
                            onDragStart={() => (dragItemIndex = index)}
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={() => handleSort(dragItemIndex, index)}
                            style={{
                                width: 120,
                                textAlign: 'center',
                                position: 'relative',
                                borderRadius: 8,
                                overflow: 'hidden',
                            }}
                        >
                            <div style={{ position: 'relative', boxSizing: "border-box" }}>
                                {file.status === 'uploading' && (
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            backgroundColor: 'rgba(255,255,255,0.7)',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            zIndex: 10,
                                            boxSizing: "border-box"
                                        }}
                                    >
                                        <Progress type="circle" percent={progress || 0} size={50} />
                                    </div>
                                )}

                                <img
                                    src={file.thumbUrl || file.url}
                                    style={{
                                        width: '100%',
                                        height: 100,
                                        objectFit: 'cover',
                                        border: isThumbnail || isHover ? '2px solid #1890ff' : '1px solid #f0f0f0',
                                        borderRadius: 8,
                                        cursor: 'pointer',
                                        display: 'block',
                                        boxSizing: "border-box"
                                    }}
                                    onClick={() => onPreview(file)}
                                />

                                <div
                                    onClick={() => onPreview(file)}
                                    style={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        backgroundColor: 'rgba(0,0,0,0.5)',
                                        color: '#fff',
                                        borderRadius: '50%',
                                        padding: 8,
                                        cursor: 'pointer',
                                        opacity: 0,
                                        transition: 'opacity 0.3s',
                                    }}
                                    className="eye-hover"
                                >
                                    <EyeOutlined style={{ fontSize: 20 }} />
                                </div>

                                <Dropdown
                                    trigger={['click']}
                                    menu={{
                                        items: getMenuItems(file),
                                        onClick: ({ key }) => handleMenuClick(file, { key }),
                                    }}
                                >
                                    <EllipsisOutlined
                                        className='ellipsisHover'
                                        style={{
                                            position: 'absolute',
                                            top: 4,
                                            right: 4,
                                            fontSize: 18,
                                            color: '#fff',
                                            backgroundColor: 'rgba(0,0,0,0.45)',
                                            borderRadius: '50%',
                                            padding: 4,
                                            cursor: 'pointer',
                                        }}
                                    />
                                </Dropdown>
                            </div>
                            {label && <div style={{ marginTop: 4 }}><Badge color="green" text={label} /></div>}
                        </div>
                    );
                })}

                {fileList.length < maxUploads && (
                    <div style={{}}>

                        <Dropdown.Button
                            className='UploadBtnDropdown'
                            menu={{
                                items: menuProps.Uploaditems,
                                className: "dropdownList"
                            }}
                            trigger={['click']}
                        >
                            <Upload
                                className='UploadBtn'
                                listType="picture-card"
                                fileList={[]}
                                showUploadList={false}
                                disabled={fileList.length >= maxUploads}
                                accept="image/*"
                                customRequest={async ({ file, onSuccess, onError, onProgress }) => {
                                    const isImage = file.type.startsWith("image/");
                                    if (!isImage) {
                                        triggerNotification({
                                            type: 'error',
                                            title: 'Error!',
                                            message: 'Only image files are allowed',
                                        });
                                        return;
                                    }
                                    if (fileList.length >= maxUploads) {
                                        onError(new Error('Maximum number of files reached'));
                                        return;
                                    }

                                    const tempUid = `${Date.now()}`;
                                    const newFile = {
                                        saved_id: "",
                                        thumbUrl: URL.createObjectURL(file),
                                        uid: tempUid,
                                        name: file.name,
                                        status: "uploading",
                                        originFileObj: file
                                    };

                                    setFileList((prev) => [...prev, newFile]);

                                    try {
                                        // Simulate progress
                                        let percent = 0;
                                        const progressInterval = setInterval(() => {
                                            percent += 10;
                                            onProgress({ percent });
                                            setUploadProgress(prev => ({ ...prev, [tempUid]: percent }));
                                            if (percent >= 90) {
                                                clearInterval(progressInterval);
                                            }
                                        }, 100);

                                        const uploaded_url = await commonApiService.upload_image_to_bucket(file);

                                        clearInterval(progressInterval);
                                        onProgress({ percent: 100 });
                                        setUploadProgress(prev => {
                                            const updated = { ...prev };
                                            delete updated[tempUid];
                                            return updated;
                                        });

                                        // Update file in fileList
                                        setFileList((prev) =>
                                            prev.map((f) =>
                                                f.uid === tempUid
                                                    ? { ...f, status: 'done', thumbUrl: uploaded_url }
                                                    : f
                                            )
                                        );

                                        onSuccess("ok");
                                    } catch (err) {
                                        console.error("Upload failed:", err);
                                        onError(err);
                                    }
                                }}

                            >
                                {uploadButton}
                            </Upload>
                        </Dropdown.Button>


                    </div>
                )}
            </div>

            <input
                type="file"
                accept="image/*"
                ref={replaceInputRef}
                style={{ display: 'none' }}
                onChange={handleReplaceFile}
            />

            <Modal
                className='previewVisibleModal'
                open={previewVisible}
                footer={null}
                onCancel={() => setPreviewVisible(false)}
                closable={false}
                centered
                width="100%"
                style={{ maxWidth: '100vw', height: '100vh', top: 0, padding: 0 }}
                mask={false}
                styles={{
                    padding: 0,
                    height: '100%',
                    width: '100%',
                    overflow: 'hidden',
                    position: 'fixed',
                    top: '0',
                    left: '0'
                }}
            >
                <div
                    onClick={() => setPreviewVisible(false)}
                    style={{
                        backgroundColor: 'rgba(0,0,0,0.85)',
                        height: '100%',
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{ textAlign: 'center', color: '#fff', boxSizing: "border-box" }}
                    >
                        <img alt="Preview" src={previewImage} style={{ maxHeight: '80vh', maxWidth: '80vw' }} />
                        <div className='preview-popup-footer'>
                            <div style={{ fontSize: 12 }}>
                                <div>{previewTitle}</div>
                                <div style={{ marginTop: 4, color: '#ccc' }}>{previewMeta}</div>
                            </div>
                            <button className='CopyLinkBnt' onClick={handleCopyLink}>
                                Copy Link
                            </button>
                            <button   
                            disabled = {!downloadImage}
                            className={downloadImage + 'abc'}  
                                onClick={handleDownload}
                                style={{ background: '#555', border: 'none', color: 'white', padding: '6px 12px', borderRadius: 4, cursor: downloadImage ? "pointer" : "not-allowed" }}
                            >
                                Download
                            </button>
                            <button className='preview-popup-close' onClick={() => setPreviewVisible(false)}>
                                <CloseOutlined />
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal
                className='UploadUrlModal'
                open={urlModalVisible}
                onCancel={() => {
                    setUrlModalVisible(false);
                    setImageUrlInput('');
                    setUrlError('');
                }}
                onOk={async () => {
                    const isValidImageUrl = (url) => {
                        return /\.(jpg|jpeg|png)(\?.*)?$/i.test(url);
                    };

                    if (!imageUrlInput || !isValidImageUrl(imageUrlInput)) {
                        setUrlError('Please enter a valid image URL (jpg, png)');
                        return;
                    }

                    if (fileList.length >= maxUploads) {
                        setUrlError(`You can only upload up to ${maxUploads} images.`);
                        return;
                    }

                    const uid = `${Date.now()}`;
                    const name = imageUrlInput.split('/').pop().split('?')[0];

                    const newFile = {
                        uid,
                        name,
                        status: 'uploading',
                        originFileObj: null,
                        thumbUrl: imageUrlInput,
                    };

                    setFileList((prev) => [...prev, newFile]);

                    let percent = 0;
                    setUploadProgress((prev) => ({ ...prev, [uid]: percent }));

                    const progressInterval = setInterval(() => {
                        percent += 10;
                        setUploadProgress((prev) => ({ ...prev, [uid]: percent }));
                        if (percent >= 90) {
                            clearInterval(progressInterval);
                        }
                    }, 100);

                    // Simulate async behavior (you can add API call here if needed)
                    setTimeout(() => {
                        clearInterval(progressInterval);
                        setUploadProgress((prev) => {
                            const updated = { ...prev };
                            delete updated[uid];
                            return updated;
                        });

                        setFileList((prev) =>
                            prev.map((f) =>
                                f.uid === uid ? { ...f, status: 'done' } : f
                            )
                        );

                        setImageUrlInput('');
                        setUrlError('');
                        setUrlModalVisible(false);
                    }, 1200); // adjust time as needed
                }}


                title="Add Image by URL"
                okText="Add"
            >
                <Input
                    placeholder="Paste image URL here..."
                    value={imageUrlInput}
                    onChange={(e) => {
                        setImageUrlInput(e.target.value);
                        if (urlError) setUrlError('');
                    }}
                />
                <p className='ErrorMessage' style={{ color: 'red', marginTop: '8px' }}>
                    {urlError}
                </p>
            </Modal>
        </>
    );
};

export default UploadButton;
